import { ApolloClient, NormalizedCacheObject, useQuery } from '@apollo/client';

import MAIN_SLIDER_QUERY from 'graphql/main/queries/mainSlider.graphql';

import type { MainSliderQuery } from 'graphql/types';

export const useMainSlider = () => useQuery<MainSliderQuery>(MAIN_SLIDER_QUERY);

export const getMainSliderSsr = async (
  client: ApolloClient<NormalizedCacheObject>
) => {
  try {
    await client.query({
      query: MAIN_SLIDER_QUERY,
    });
  } catch (err) {
    console.log(err);
  }
};
